// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + ({"34":"application","886":"create"}[chunkId] || chunkId) + "-legacy." + {"34":"1c61ce27","169":"1730f331","886":"89f67139"}[chunkId] + ".js";
};